var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":require("../assets/draw2025/index_bg.jpg"),"fit":"contain","width":"100%","alt":""}})])}]

export { render, staticRenderFns }